import moment from "moment";
import { Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";

export default function DynamicFromNow({
  date,
  content,
  contentStyle
}: {
  content?: string;
  date: string | null | undefined;
  contentStyle?: React.CSSProperties;
}) {
  const [updater, setUpdater] = useState(Date.now());
  const interval = useRef<NodeJS.Timeout>();

  useEffect(() => {
    const parsedDate = date && !date.endsWith('Z') ? date + 'Z' : date;
    const diff = moment.duration(moment(updater).diff(parsedDate)).asHours();
    if (diff < 1) {
      interval.current = setInterval(() => {
        setUpdater(Date.now());
      }, 5000);
    }
    return () => {
      interval.current && clearInterval(interval.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const parsedDate = date && !date.endsWith('Z') ? date + 'Z' : date;
    const diff = moment.duration(moment(updater).diff(parsedDate)).asHours();
    if (diff >= 1) {
      interval.current && clearInterval(interval.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updater]);

  return (
    <Tooltip title={moment(date && !date.endsWith('Z') ? date + 'Z' : date).format("DD.MM.YYYY HH:mm:ss")}>
      <span style={contentStyle}>{content}</span> <span>{moment(date && !date.endsWith('Z') ? date + 'Z' : date).fromNow()}</span>
    </Tooltip>
  );
}
